import { jsx as _jsx } from "react/jsx-runtime";
import { css } from './styles.js';
const colorMap = {
    primary: 'var(--k-accent)',
    success: 'var(--k-success)',
    danger: 'var(--k-danger)',
    warning: 'var(--k-warning)',
};
const sizeMap = {
    sm: { size: '20px', strokeWidth: 2 },
    md: { size: '32px', strokeWidth: 2 },
    lg: { size: '48px', strokeWidth: 2.5 },
};
export const Spinner = ({ size = 'md', color = 'primary', className, style }) => {
    const { size: spinnerSize, strokeWidth } = sizeMap[size] ?? sizeMap.md;
    const spinnerColor = colorMap[color] ?? 'var(--k-accent)';
    const containerStyle = css({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: spinnerSize,
        height: spinnerSize,
        // C-02: Reference keyframe defined in index.css, not inline
        animation: 'kSpin 1s linear infinite',
    }, style);
    const circleStyle = {
        r: '45%',
        fill: 'none',
        stroke: spinnerColor,
        strokeWidth,
        strokeLinecap: 'round',
        strokeDasharray: '251.2',
        strokeDashoffset: '62.8',
    };
    return (_jsx("svg", { viewBox: "0 0 100 100", style: containerStyle, className: className, "aria-label": "Loading", role: "status", children: _jsx("circle", { cx: "50", cy: "50", ...circleStyle }) }));
};
//# sourceMappingURL=Spinner.js.map